// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel {
    static getAttributeTypeMap() {
        return EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.attributeTypeMap;
    }
}
EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.discriminator = undefined;
EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.additionalProperties = false;
EnterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.attributeTypeMap = [
    {
        "name": "patientId",
        "baseName": "patientId",
        "type": "string"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "middleName",
        "baseName": "middleName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "suffix",
        "baseName": "suffix",
        "type": "string"
    },
    {
        "name": "nickname",
        "baseName": "nickname",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "primaryLanguageId",
        "baseName": "primaryLanguageId",
        "type": "number"
    },
    {
        "name": "isUsResident",
        "baseName": "isUsResident",
        "type": "boolean"
    },
    {
        "name": "householdSize",
        "baseName": "householdSize",
        "type": "number"
    },
    {
        "name": "socialSecurityNumber",
        "baseName": "socialSecurityNumber",
        "type": "string"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": ""
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": ""
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": ""
    },
    {
        "name": "raceCode",
        "baseName": "raceCode",
        "type": "string"
    },
    {
        "name": "ethnicityCode",
        "baseName": "ethnicityCode",
        "type": "string"
    },
];
//# sourceMappingURL=enterpriseCoordinatorPatientServiceModelsPatientUpsearchModel.js.map